/**
 * Trends API (RTK Query)
 * Google Trends analysis with Amazon keyword suggestions, cached per marketplace (geo).
 */

import { createApi } from '@reduxjs/toolkit/query/react';
import { apiClientBaseQuery } from '@/store/api/apiClientBaseQuery';
import type { TrendResult, TrendsAnalysisResponse } from '@/store/api/searchNicheApi';

// ─── API ───────────────────────────────────────────────────────────────────────

export const trendsApi = createApi({
    reducerPath: 'trendsApi',
    baseQuery: apiClientBaseQuery,
    // The analysis is slow and rarely changes — keep it cached for 10 minutes.
    keepUnusedDataFor: 600,
    endpoints: (builder) => ({
        // Arg is the geo (marketplace) code — RTK Query caches one entry per geo.
        getTrendsAnalysis: builder.query<TrendResult[], string>({
            query: (geo) => ({ url: 'trends/analysis', params: { geo } }),
            transformResponse: (res: TrendsAnalysisResponse) => (res?.results ?? []).filter(r => r.keep),
        }),
    }),
});

export const { useGetTrendsAnalysisQuery } = trendsApi;
